import { DatesHelpers } from "./dates.helpers";

export class PlanningHelpers {
  static getFirstWeekSelection() {
    const start = DatesHelpers.getDayjs();
    const end = DatesHelpers.getDayjs().add(6, "day");
    return { start: start.toDate(), end: end.toDate() };
  }

  static getCalendarShiftsBoundaries({ date, additionnalMonth = 0 }) {
    const startMoment = DatesHelpers.getDayjs(date);
    // we select the first day of the first week (as it's often a different month)
    const start = startMoment.clone().startOf("month").startOf("week").toDate();

    const end = startMoment.clone().add(additionnalMonth, "month").endOf("month").add(2, "week").endOf("week").toDate();

    return { start, end };
  }
}
